export default __webpack_public_path__ + "static/media/NeueMontreal-BoldItalic.3d439d11.woff";